import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import HomeCTA from "../HomeCTA/HomeCTA";
import "./Projects.css";

// Project Images
import solarInstallImg from "../../assets/PowerGridProjects/solar_install.webp";
import windEnergyImg from "../../assets/PowerGridProjects/wind_energy.webp";
import energyStorageImg from "../../assets/PowerGridProjects/energy_storage.webp";
import hydroPowerImg from "../../assets/PowerGridProjects/hydro_power.webp";

const projectsList = [
  {
    number: "01",
    slug: "solar-installation",
    title: "Solar Installation",
    desc: "Installed a rooftop solar system for a residential home.",
    client: "Canal Villere",
    type: "Residential",
    budget: "$30,000",
    image: solarInstallImg,
  },
  {
    number: "02",
    slug: "wind-energy",
    title: "Wind Energy",
    desc: "Set up small wind turbines to power places off the grid.",
    client: "Joshua Fowler",
    type: "Hydropower",
    budget: "$18,000",
    image: windEnergyImg,
  },
  {
    number: "03",
    slug: "energy-storage",
    title: "Energy Storage",
    desc: "Installed advanced battery storage for a facility.",
    client: "Lucy Ryan",
    type: "Residential",
    budget: "$20,000",
    image: energyStorageImg,
  },
  {
    number: "04",
    slug: "micro-hydropower",
    title: "Micro Hydropower",
    desc: "Installed a rooftop solar system for a residential home.",
    client: "Lewis Parker",
    type: "Residential",
    budget: "$26,000",
    image: hydroPowerImg,
  },
];

const Projects = () => {
  const navigate = useNavigate();

  const cardVariants = {
    hidden: { opacity: 0, y: 35 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.7,
        ease: [0.25, 0.1, 0.25, 1],
      },
    },
  };

  return (
    <div className="powergrid-projects-page">
      {/* Top Header Section */}
      <section className="powergrid-header-section">
        <div className="container">
          <motion.div
            className="powergrid-title-block"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.25, 0.1, 0.25, 1] }}
          >
            <h1 className="powergrid-main-heading">
              See How We're Impacting<br />the world
            </h1>
          </motion.div>
        </div>
      </section>

      {/* Projects Cards List Section */}
      <section className="powergrid-cards-section">
        <div className="container">
          <div className="powergrid-cards-stack">
            {projectsList.map((project, index) => (
              <motion.div
                key={project.number}
                className="powergrid-project-card"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, margin: "-50px" }}
                variants={cardVariants}
              >
                {/* Left Information Card */}
                <div className="project-info-card">
                  <div className="project-number">{project.number}</div>

                  <div className="project-title-group">
                    <h3 className="project-card-title">{project.title}</h3>
                    <p className="project-card-desc">{project.desc}</p>
                  </div>

                  <div className="project-meta-list">
                    <div className="meta-item">
                      <span className="meta-label">Client:</span>
                      <span className="meta-value">{project.client}</span>
                    </div>
                    <div className="meta-item">
                      <span className="meta-label">Type:</span>
                      <span className="meta-value">{project.type}</span>
                    </div>
                    <div className="meta-item">
                      <span className="meta-label">Budget:</span>
                      <span className="meta-value">{project.budget}</span>
                    </div>
                  </div>

                  <div className="project-action-wrap">
                    <button
                      type="button"
                      className="see-details-btn"
                      onClick={() => navigate(`/projects/${project.slug}`)}
                    >
                      <span className="see-details-text">SEE DETAILS</span>
                      <div className="arrow-circle">
                        <i className="bi bi-arrow-right"></i>
                      </div>
                    </button>
                  </div>
                </div>

                {/* Right Visual Image Card */}
                <div className="project-image-card">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="project-img"
                    loading="lazy"
                  />
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section from Home Page */}
      <div className="projects-cta-wrapper">
        <HomeCTA />
      </div>
    </div>
  );
};

export default Projects;
